import { render } from "./ModuleBorrowerLiabilities.vue?vue&type=template&id=3fc8b34c"
import script from "./ModuleBorrowerLiabilities.vue?vue&type=script&lang=js"
export * from "./ModuleBorrowerLiabilities.vue?vue&type=script&lang=js"

import "./ModuleBorrowerLiabilities.vue?vue&type=style&index=0&id=3fc8b34c&lang=css"

import exportComponent from "/home/alexey/mv/mortgageware/vendor/sudoux/cms/Sudoux/Cms/FormBundle/Resources/views/Vuejs/Apps/formbuilder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QCheckbox,QField});
